import React from "react";
import AllReports from "../../components/Reports.js/AllReports";

function Reports() {
  return (
    <div>
      <AllReports />
    </div>
  );
}

export default Reports;
